import { env } from 'process';
export const appVersion: string = "02112021";
//const environmentVersion: string = env.npm_package_version || 1 + "-dev";

export const environment = {
  production: true,
  apiConfig: {
    baseUrl: "https://ecomm.fotiou.com/backend/api/"
  },
  storageKeys: {
    userInfo: `fotiou.userInfo.${appVersion}`,
    cart: `fotiou.cart.${appVersion}`,
  },
  iframeAuth: {
    // Exact origin(s) of the PARENT app that embeds this Angular app in an iframe.
    // Do NOT use '*' in production; list only the trusted parent portal origin(s).
    allowedOrigins: ['https://ecomm.fotiou.com', 'http://localhost/ericd213.sg-host.com', 'https://ericd213.sg-host.com', 'http://localhost/ecomm', 'http://localhost']
  }
};
